module.exports = __webpack_public_path__ + "img/d10sj-btn.0ecaa3f2.png";